import { Navigate, Route, Routes } from "react-router-dom";
import { AdminLayout } from "./layout/AdminLayout";
import { AlertDispatchesPage } from "./pages/AlertDispatchesPage";
import { AlertPrefsPage } from "./pages/AlertPrefsPage";
import { CreditLedgerPage } from "./pages/CreditLedgerPage";
import { EmailVerificationPage } from "./pages/EmailVerificationPage";
import { FeedbackPage } from "./pages/FeedbackPage";
import { JobRunsPage } from "./pages/JobRunsPage";
import { LoginPage } from "./pages/LoginPage";
import { OrdersPage } from "./pages/OrdersPage";
import { OverviewPage } from "./pages/OverviewPage";
import { BillingPlansPage } from "./pages/BillingPlansPage";
import { SubscriptionsPage } from "./pages/SubscriptionsPage";
import { UsersPage } from "./pages/UsersPage";
import { RequireAuth } from "./routes/RequireAuth";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<AdminLayout />}>
          <Route path="/" element={<Navigate to="/overview" replace />} />
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/subscriptions" element={<SubscriptionsPage />} />
          <Route path="/billing-plans" element={<BillingPlansPage />} />
          <Route path="/credit-ledger" element={<CreditLedgerPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/job-runs" element={<JobRunsPage />} />
          <Route path="/alert-dispatches" element={<AlertDispatchesPage />} />
          <Route path="/alert-prefs" element={<AlertPrefsPage />} />
          <Route path="/email-verification" element={<EmailVerificationPage />} />
          <Route path="*" element={<Navigate to="/overview" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
